import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useCrewWageColumn, CrewContractColumn } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<CrewContractColumn>
    useData={useCrewWageColumn}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
